export const ACCOUNT_BALANCE_CHANGED = 'ACCOUNT_BALANCE_CHANGED';